// src/components/SubscriptionCard.js
import React from 'react';
import './SubscriptionCard.css';

const SubscriptionCard = ({ title, description, price, onClick, selected }) => {
  return (
    <div className={`subscription-card ${selected ? 'selected' : ''}`} onClick={onClick}>
      <h4>{title}</h4>
      <p>{description}</p>
      <h2>{price}</h2>
      <button className="choose-button">{selected ? 'Chosen' : 'Choose'}</button>
    </div>
  );
};

export default SubscriptionCard;